import React from 'react';
import { Link } from 'react-router-dom';
const logoImage = process.env.PUBLIC_URL + '/full-logo-myntar.svg';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-brand">
          <img 
            src={logoImage} 
            alt="Myntar.tech" 
            className="footer-logo"
          />
          <p>
            Plataforma española de avatares inteligentes con IA conversacional 
            avanzada para retail, hostelería y turismo. Tecnología GDPR-nativa.
          </p>
          
        </div>
         <div className="footer-column">
          <h4>Contacto</h4>
          <div className="footer-contact">
            <div className="footer-contact-item">📧 contact@myntar.tech</div>
            <div className="footer-contact-item">🌐 www.myntar.tech</div>
            <div className="footer-contact-item">📍 Córdoba, España</div>
          </div>
        </div>
        <div className="footer-column">
          <h4>Empresa</h4>
          <ul className="footer-links">
            <li><Link to="/nosotros">Sobre Nosotros</Link></li>
            <li><Link to="/nosotros">Equipo</Link></li>
            <li><a href="#contacto">Carreras</a></li>
            <li><a href="#contacto">Blog</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Soluciones</h4>
          <ul className="footer-links">
            <li><a href="#casos">Retail</a></li>
            <li><a href="#casos">Hostelería</a></li>
            <li><a href="#casos">Educación</a></li>
            <li><a href="#casos">Cultura</a></li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Legal</h4>
          <ul className="footer-links">
            <li><Link to="/aviso-legal">Aviso Legal</Link></li>
            <li><Link to="/privacidad">Privacidad</Link></li>
            <li><Link to="/terminos">T&eacute;rminos</Link></li>
            <li><Link to="/cookies">Cookies</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025 Myntar.tech - Todos los derechos reservados</p>
        <p>Hecho con ❤️ en España</p>
      </div>
    </footer>
  );
};

export default Footer;
